var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "compliance-brain-menu",
      attrs: {
        href: _vm.COMPLIANCE_BRAIN_URL,
        target: "_blank",
        rel: "noopener noreferrer"
      },
      on: {
        click: _vm.prepareLink,
        auxclick: _vm.prepareLink,
        contextmenu: _vm.prepareLink
      }
    },
    [
      _c(
        "svg",
        {
          staticClass: "compliance-brain-icon",
          attrs: {
            width: "20",
            height: "20",
            viewBox: "0 -3 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M12.2622 3.23438L15.4095 11.3663L23.5414 14.5136L15.4095 17.6609L12.2622 25.7928L9.11491 17.6609L0.982956 14.5136L9.11491 11.3663L12.2622 3.23438Z",
              fill: "currentColor"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M24.4446 0L26.2797 4.73992L31.0196 6.57501L26.2797 8.4101L24.4446 13.1501L22.6095 8.4101L17.8695 6.57501L22.6095 4.73992L24.4446 0Z",
              fill: "currentColor"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "compliance-brain-title" }, [
        _vm._v("合规大脑")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "compliance-brain-tag" }, [_vm._v("Agent")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5813b466", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5813b466","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ComplianceBrainMenu.vue
// module id = null
// module chunks = 